/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client'

import { Toast, ToastProvider } from '@/components/ui/shadcn/toast/Toast'
import { ToastClose } from '@/components/ui/shadcn/toast/ToastClose'
import { ToastDescription } from '@/components/ui/shadcn/toast/ToastDescription'
import { ToastTitle } from '@/components/ui/shadcn/toast/ToastTitle'
import { ToastViewport } from '@/components/ui/shadcn/toast/ToastViewport'
import { useToast } from '@/components/ui/shadcn/toast/useToast'

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className={'grid gap-1'}>
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
